// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3CDKo","row":"ProcedureTreatmentSummary_row__3mi3e"};